import { useTranslation } from 'react-i18next';

import type { DocsOperation } from '../../generated/reference';
import { CodeBlock } from '../code-block';
import { SchemaViewer } from '../schema-viewer';

import { exampleCode } from './endpoint-example';
import { EndpointSection } from './endpoint-section';

/** The body schema and the recorded request body. */
export function EndpointRequestBody({ operation }: { operation: DocsOperation }) {
  const { t } = useTranslation('docs');
  const body = operation.requestBody;
  if (!body) return null;
  const example = operation.examples.request?.body;

  return (
    <EndpointSection id="request-body" title={t('endpoint.requestBody.title')}>
      {body.required ? null : (
        <p className="text-muted-foreground text-sm">{t('endpoint.requestBody.optional')}</p>
      )}
      <SchemaViewer schema={body} />
      {example !== undefined ? (
        <CodeBlock {...exampleCode(example)} label={t('endpoint.requestBody.example')} />
      ) : null}
    </EndpointSection>
  );
}
